export const ENV_COOKIE_LOGIN_NAME = import.meta.env.VITE_COOKIE_LOGIN_NAME;
export const ENV_DARK_MODE = import.meta.env.VITE_COOKIE_DARK_MODE;
export const ENV_API_URL = import.meta.env.VITE_API_URL;
export const ENV_NEMURU_PAYBYLINK_URL = import.meta.env.VITE_NEMURU_PAYBYLINK_URL;
export const ENV_NEMURU_CDN_URL = import.meta.env.VITE_NEMURU_CDN_URL;
export const ENV_NEMURU_BORROWER_URL = import.meta.env.VITE_NEMURU_BORROWER_URL;
export const ENV_NEMURU_JS_URL = import.meta.env.VITE_NEMURU_JS_URL;
export const ENV_CHECKOUT_B2B_URL = import.meta.env.VITE_CHECKOUT_B2B_URL;
export const ENV_IS_PROD = import.meta.env.VITE_IS_PROD;
export const ENV_ENV = import.meta.env.VITE_ENV;
export const ENV_AWS_S3_BUCKET_URL = import.meta.env.VITE_AWS_S3_BUCKET_URL;
export const ENV_HPP_URL = import.meta.env.VITE_HPP_URL;
export const ENV_MAPS_API_KEY = import.meta.env.VITE_MAPS_API_KEY;
